export default class CustomerTypeActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static ERROR_SERVER='ERROR_SERVER';
  static ERROR_DELETE='ERROR_DELETE';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static GET_HELPER_TYPE_CUSTOMER='GET_HELPER_TYPE_CUSTOMER';
  static SUCCESS_DATA='SUCCESS_DATA';
  static RESET_LIST='RESET_LIST';

  static submit(){
    return {
      type: CustomerTypeActions.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type: CustomerTypeActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type: CustomerTypeActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type: CustomerTypeActions.VIEW_DATA,
      payload: data
    };
  }

  static delete(data) {
    return {
      type: CustomerTypeActions.DELETE_DATA
    };
  }
  static resetList() {
    return {
      type: CustomerTypeActions.RESET_LIST
    };
  }
  static list(data) {
    return {
      type: CustomerTypeActions.SHOW_DATA,
      payload: data
    };
  }
  static error(error){
    return {
      type: CustomerTypeActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type: CustomerTypeActions.SUCCESS_DATA,
    };
  }
  static process(){
    return {
      type: CustomerTypeActions.PROCESS_DATA,
    };
  }
  static reset(){
    return {
      type: CustomerTypeActions.RESET_DATA,
    };
  }
  static helper(data){
    return {
      type: CustomerTypeActions.GET_HELPER_TYPE_CUSTOMER,
      payload:data
    };
  }
  static errorInternal(error){
    return {
      type: CustomerTypeActions.ERROR_SERVER,
      payload: error
    };
  }
  static errorDelete(error){
    return {
      type: CustomerTypeActions.ERROR_DELETE,
      payload: error
    };
  }
  
}